import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel";
import * as projection from "@arcgis/core/geometry/projection";
import { useStore } from "../../stores/store.ts";
let sketchViewModel: SketchViewModel;

export const toggleTriView = ({ wasActive }) => {
  const { setTooltipText, mapView, bufferLayer, toggleActiveItem } =
    useStore.getState();
  if (wasActive) {
    sketchViewModel.destroy();
    setTooltipText("");
    return;
  }
  setTooltipText(
    wasActive ? "" : "Click the map to load Tri-View at that point"
  );
  if (!mapView || !bufferLayer) {
    return;
  }
  sketchViewModel = new SketchViewModel({
    view: mapView,
    layer: bufferLayer,
    defaultUpdateOptions: {
      toggleToolOnClick: false,
    },
  });
  sketchViewModel.create("point");
  sketchViewModel.on("create", async (e) => {
    if (e.state === "complete") {
      setTooltipText("");
      toggleActiveItem("triView");
      bufferLayer.remove(e.graphic);
      await projection.load();
      const projectionRes = projection.project(e.graphic.geometry, {
        wkid: 4326,
      });
      const { x, y } = projectionRes;
      const url = `https://www.mapchannels.com/dualmaps6/map.htm?lng=${x}&lat=${y}&z=16&gm=0&bm=2&mw=1&be=1&mv=1&md=1&mi=4&pt=&pd=&sh=0&sp=0&sz=1&panel=mbs`;
      window.open(url, "_blank");
    }
  });
};
